module.exports = __webpack_public_path__ + "img/login-code.3ba458ac.jpg";